<template>
  <div class="checkout" v-if="Object.keys(this.booking_data).length">
    <!-- nel js c'è un router push a 'detail' se non trovo booking_data (es. se refresho la pagina checkout). questo ulteriore controllo è per evitare un undefined rischioso a template -->
    <b-container v-if="!(loading || purchasing)" class="checkout__content">
      <button-back />
    </b-container>
    <b-container class="checkout__content">
      <section v-if="loading" class="section section--loader">
        <loader size="large" :show_timing_slot="true" />
      </section>
      <b-row>
        <b-col sm="12" md="7" lg="8" xl="9">
          <div v-if="!loading">
            <div v-if="!checkout_ok">
              <div class="checkout--panel" compact>
                <flight-pad-details
                  :flight_offer="selected_flight_offer"
                  collapsed
                />
              </div>
              <additional-services-booked
                :flight_offer="selected_flight_offer"
                :travelers="travelers_details"
              />
              <content-section
                title="I contatti a cui riceverai le informazioni sul tuo volo"
              >
                <template>
                  <div
                    v-for="(contact, index) in booking_data
                      .flightCreateOrderBody.data.contacts"
                    v-bind:key="_uid + index"
                  >
                    <div class="checkout--user-info">
                      <vb-icon name="user" :size="16"></vb-icon>
                      {{ contact.addresseeName.firstName }}
                      {{ contact.addresseeName.middleName }}
                      {{ contact.addresseeName.lastName }}
                    </div>
                    <div class="checkout--user-info" style="margin-left: 4px">
                      <vb-icon name="email" :size="16"></vb-icon>
                      {{ contact.emailAddress }}
                    </div>
                    <div class="checkout--user-info">
                      <vb-icon name="mobile" :size="16"></vb-icon>
                      +{{ contact.phones[0].countryCallingCode }}
                      {{ contact.phones[0].number }}
                    </div>
                    <hr
                      v-if="
                        index <
                        booking_data.flightCreateOrderBody.data.contacts
                          .length -
                          1
                      "
                    />
                  </div>
                </template>
              </content-section>
              <content-section
                title="Elenco dei passeggeri"
                description="Verifica che nomi e date di nascita siano corrispondenti a
                  quelli riportati nel documento di identità con cui verrà fatto
                  l'imbarco"
              >
                <template>
                  <div
                    v-for="(traveler, index) in booking_data
                      .flightCreateOrderBody.data.travelers"
                    v-bind:key="_uid + index"
                  >
                    <div class="checkout--user-info">
                      <vb-icon name="user" :size="16"></vb-icon>
                      <span>
                        {{ traveler.name.firstName }}
                        {{ traveler.name.middleName }}
                        {{ traveler.name.lastName }}
                      </span>
                      <span style="font-size: 30px; line-height: 0">
                        &middot;
                      </span>
                      <span>{{ reverse_date(traveler.dateOfBirth) }}</span>
                    </div>
                  </div>
                </template>
              </content-section>
            </div>
            <div v-else class="checkout--panel" compact>
              <p v-if="checkout_msg">
                <b-alert variant="success" v-html="checkout_msg" show />
              </p>
              <!--<p>
                                <b>codice di conferma</b>: {{ checkout_confirmcode }}
                            </p>-->
            </div>
          </div>
        </b-col>
        <b-col m="12" md="5" lg="4" xl="3">
          <sidebar
            :integration="integration"
            :availability="sidebar_availability"
            :live_price="live_price"
            :loading="loading"
            :purchasing="purchasing"
            :completed="checkout_ok"
            :discount_codes="discount_codes"
            @purchase="
              (sidebar_data) => {
                purchase(sidebar_data);
              }
            "
            @commit="
              (event) => {
                this.$store.commit(event.name, event.payload);
              }
            "
          >
            <template #resume>
              <sidebar-resume
                :flight_offers="[selected_flight_offer]"
                contained
              />
            </template>

            <template #message>
              <div v-if="checkout_ok" class="vb-sidebar__block">
                <div v-if="checkout_msg" v-html="checkout_msg"></div>
              </div>
              <div v-if="!checkout_ok && purchasing" class="text-center">
                <loader>
                  <template>
                    <span>
                      Prenotazione in corso... non abbandonare o ricaricare la
                      pagina!
                    </span>
                  </template>
                </loader>
              </div>
            </template>
          </sidebar>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Vue from "vue";
import { service_handler } from "@/services";
import { parse_flight_offer_for_ecommerce_item } from "@liveflight/utilities/mixins";
import {
  reverse_date,
  custom_event,
  get_availability,
} from "@/utilities/commons";
import FlightPadDetails from "@liveflight/components/blocks/flight-pad/flight-pad-details/flight-pad-details";
import SidebarResume from "@liveflight/components/blocks/resume/resume";
import ContentSection from "@liveflight/components/blocks/wrappers/content-section.vue";
import Sidebar from "@components/blocks/sidebar/sidebar";
import AdditionalServicesBooked from "@liveflight/components/blocks/additional-services-booked.vue";

export default {
  name: "checkout",
  components: {
    "additional-services-booked": AdditionalServicesBooked,
    "content-section": ContentSection,
    "flight-pad-details": FlightPadDetails,
    "sidebar-resume": SidebarResume,
    sidebar: Sidebar,
  },
  props: {},
  data() {
    return {
      vm: this,
      loading: true,
      purchasing: false,
      integration: Vue.prototype.$config.integration,
      checkout_ok: false,
      checkout_msg: "",
    };
  },
  computed: {
    discount_codes() {
      return this.$store.state.discount_codes;
    },
    live_price() {
      return this.booking_data.live_price || "0";
    },
    sidebar_availability() {
      return get_availability(this.live_price);
    },
    selected_flight_offer() {
      return this.$store.state.liveflight.flight_offer;
    },
    booking_data: {
      get() {
        return this.$store.state.booking_data;
      },
      set(value) {
        this.$store.commit("booking_data", value);
      },
    },
    travelers_details() {
      try {
        return this.booking_data.flightCreateOrderBody.data.travelers || [];
      } catch {
        return [];
      }
    },
    flight_offer() {
      return this.$store.state.liveflight.flight_offer;
    },
  },
  created() {
    this.reverse_date = reverse_date;
    this.custom_event = custom_event;
    // se non trovo booking data rimando al dettaglio
    if (!Object.keys(this.booking_data).length) {
      this.$router.replace("detail");
      return;
    }

    // per evitare undefined quando li popolo dinamicamente
    if (this.booking_data.payments == undefined) {
      this.booking_data.payments = {
        cc: {},
        welfare: {},
        discountCodes: {},
      };
    }
  },
  mounted() {
    custom_event(
      "initiateCheckout",
      this.selected_flight_offer.price.grandTotal,
    );

    let item = parse_flight_offer_for_ecommerce_item(
      this.selected_flight_offer,
    );

    custom_event({
      event: "begin_checkout",
      ecommerce: {
        currency: "EUR",
        items: [item],
        transaction_id: "",
        affiliation: "",
        value: item.price,
        tax: 0,
        shipping: 0,
        coupon: "",
      },
    });
    custom_event({
      event: "add_to_cart",
      ecommerce: {
        currency: "EUR",
        items: [item],
        transaction_id: "",
        affiliation: "",
        value: item.price,
        tax: 0,
        shipping: 0,
        coupon: "",
      },
    });

    this.loading = false;
  },
  methods: {
    checkout() {
      return service_handler("book", {
        bookingData: this.$store.state.booking_data,
        ...this.$store.state.liveflight.guests,
      });
    },
    purchase(sidebar_data) {
      // I pagamenti sono già preparati dalla sidebar generica
      this.booking_data.payments = sidebar_data.payments;

      // Prepara i dati guest dal payload della sidebar
      const guestPayload =
        (sidebar_data.guest && sidebar_data.guest.payload) || {};
      const guests = {
        guestFirstName: guestPayload.guestFirstName,
        guestLastName: guestPayload.guestLastName,
        guestFiscalCode: guestPayload.guestFiscalCode,
        guestEmail: guestPayload.guestEmail,
        guestEmailConf: guestPayload.guestEmailConf,
        guestPrivacy: guestPayload.guestPrivacy,
        beneficiaryId: guestPayload.beneficiaryId || 0,
      };
      if (guestPayload.guestPhone) {
        guests.guestPhone = guestPayload.guestPhone;
      }
      this.$store.commit("liveflight/guests", guests);

      this.loading = true;
      this.purchasing = true;
      this.scroll_top();

      this.checkout().then(
        (success) => {
          this.scroll_top();
          this.checkout_msg = success.data.msg;
          this.loading = false;
          this.purchasing = false;
          this.checkout_ok = true;

          if (success.status == 202) return; // asyncPayment

          if (!success.data.errors) {
            custom_event(
              "confirmedCheckout",
              this.selected_flight_offer.price.grandTotal,
            );

            let item = parse_flight_offer_for_ecommerce_item(
              this.selected_flight_offer,
            );
            custom_event({
              event: "purchase",
              ecommerce: {
                currency: "EUR",
                items: [item],
                transaction_id: success.data.confirmcode,
                affiliation: "",
                value: item.price,
                tax: 0,
                shipping: 0,
                coupon: "",
              },
            });
            if (success.data.updateAvailabilityTo)
              Vue.prototype.$config.integration.availability =
                success.data.updateAvailabilityTo;

            window.location.href =
              "/confirm/" +
              success.data.flightVoucherId.toString() +
              "/" +
              success.data.confirmcode;
          }
        },
        (error) => {
          error;
          this.loading = false;
          this.purchasing = false;
          custom_event("checkoutError");
        },
      );
    },
  },
};
</script>

<style lang="scss">
.checkout {
  &--panel {
    @extend .content-panel !optional;
    margin-bottom: 1rem !important;
  }
  &--user-info {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-bottom: 0.25rem;
  }
  .privacy-box {
    display: flex;
  }
  .btn-light {
    .chevron svg {
      width: 10px;
      height: auto;
      path {
        stroke: $cta;
      }
    }
  }

  &__content {
    padding-top: $grid-gutter-width;
  }
}
</style>
